import { IQuery } from "@/interfaces/contact-us.interface";
import { AuthClient } from "@/utils/client";

export const submitQuery = (data: IQuery) => {
  return AuthClient().post(`/common/contact-us`, data);
};
